import React, {useEffect, useState} from "react";
import { useLocation } from "react-router-dom";
import ExpenseTable from "./ExpenseTable";
import Loader from "../../../../components/Loader/Loader";
import logo from "../../../../assets/img/profile/Emblem_of_Angola.png"
export const FINANCIAL_HEAD = process.env.REACT_APP_FINANCIAL_HEAD;
export const EMBAIXADOR = process.env.REACT_APP_EMBAIXADOR;
export const COUNTRY = process.env.REACT_APP_COUNTRY;

const BankStatement = () => {
  const [loading, setLoading] = useState(false);
  const [apiData, setApiData] = useState({});
  const [reportData, setReportData] = useState([]);
  const [footerData, setFooterData] = useState({});

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // Extract query parameters
  const accountId = queryParams.get("accountId");
  const yearMonth = queryParams.get("yearMonth");
  const organizationId = queryParams.get("organizationId");
  const [orgName, setOrgName] = useState([]);
  const [cambioRate, setCambioRate] = useState([]);
  const [monthNameAndYear, setMonthNameAndYear] = useState([]);
  const [mappedApiData, setMappedApiData] = useState([]);



  useEffect(() => {
    fetchBankReport(organizationId, yearMonth);
  }, []);


  const fetchBankReport = async (organizationId, yearMonth) => {
    setLoading(true);
    try {
      // API Endpoint
      const apiUrl = `${process.env.REACT_APP_API_URL}/v1/reports/despesa-report?orgId=${organizationId}&yearMonth=${yearMonth}`;
      const userToken = localStorage.getItem("token");

      // Fetch API
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      });

      setLoading(false);

      if (response.ok) {
        const responseData = await response.json();

        // Set Organization Details
        setOrgName(responseData.data.organizationName);
        setCambioRate(responseData.data.exchangeRateText);
        setMonthNameAndYear(responseData.data.monthNameAndYear);

        // Process the API response
        if (responseData?.data?.despesaNature) {
          const mappedApiData = responseData.data.despesaNature
            .filter((item) => item.description !== "TOTAL SAIDAS") // Exclude TOTAL SAIDAS
            .map((item) => ({
              codigo: item.code, // 'description' maps to 'codigo'
              descricao: item.description, // 'description' as 'descricao'
              fr: "RP/ROT", // Fixed value for all rows
              usd: item.totalUsd || "", // Map USD amount
              eur: item.totalEur || "", // Map EUR amount
              jpy: item.totalJpy || "", // Map JPY amount
              akz: item.totalAkz || "", // Map AKZ amount
            }));

          // Add Total Row dynamically
         // Find "TOTAL SAIDAS" row for totals
        const totalRowFromApi = responseData.data.despesaNature.find(
          (item) => item.description === "TOTAL SAIDAS"
        );

        // Map TOTAL SAIDAS row into frontend structure
        const totalRow = totalRowFromApi
          ? {
              descricao: "Total", // Rename description for frontend
              fr: "",
              usd: totalRowFromApi.totalUsd || "",
              eur: totalRowFromApi.totalEur || "",
              jpy: totalRowFromApi.totalJpy || "",
              akz: totalRowFromApi.totalAkz || "",
            }
          : null;

          // Set Footer Data: Use 'saldo total' for the footer description
          // const footerData = {
          //   descricao: "Saldo Total",
          //   credit: responseData.data.totalCredit || 0,
          //   debit: responseData.data.totalDebit || 0,
          // };

          // Update State
          setMappedApiData([...mappedApiData, totalRow]);
          // setFooterData(footerData);
        }
      } else {
        console.error("Error fetching API data:", response.status);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching API data:", error);
    }
  };

  
  

  



  const handlePrint = () => {
    window.print();
  };

  return (
   <div className="p-2">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex justify-between items-center mb-4 text-black dark:text-white">
          <div className="flex-1 text-center">

          <div className="flex items-center justify-center h-[100px]">
  <img
    src={logo}
    alt="Logo"
    className="w-[60px] h-[80px] object-contain"
  />
</div>
            
            <h2 className="text-md font-bold">MINISTÉRIO DAS FINANÇAS</h2>
            <h2 className="text-md">DIRECÇÃO NACIONAL DE CONTABILIDADE</h2>
            <h2 className="mt-2 text-md font-bold">EMBAIXADA DA REPÚBLICA DE ANGOLA NO {COUNTRY}</h2>
            <h2 className="mt-2 text-md font-bold">RELAÇÃO DE DESPESAS PAGAS</h2>
            <h2 className="text-md">MÊS DE {monthNameAndYear}</h2>
            <h2 className="text-md uppercase font-bold mt-2" style={{ textAlign: 'left' }}>{orgName}</h2>
          </div>

          <div className="text-right">
            <p className="text-md text-red-600">Câmbio: {cambioRate}</p>
          </div>
        </div>

        {/* Print Button */}
        <div className="text-right mb-4">
          <button
            onClick={handlePrint}
            className="linear mt-2 w-48 rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200 print:hidden">
            Print
          </button>

        </div>

        {/* Table */}
        {mappedApiData?.length > 0 && footerData && (
        <ExpenseTable tableData={mappedApiData} footerData={footerData} />
      )}

        {/* Footer */}
        <div className="flex justify-between mt-4">
        <div>
            <p className="mt-10">Data: {apiData.reportDate}</p>
          </div>
          <div>
            <hr className="mt-10 border-t-2 my-2" style={{ borderTop: '2px solid black' }} />
            <p className="text-center">Adido Financeiro</p>
          <p className="font-bold">{FINANCIAL_HEAD}</p>
          </div>
          <div>
            <hr className="mt-10 border-t-2 my-2" style={{ borderTop: '2px solid black' }} />
            <p className="text-center">Embaixadora</p>
          <p className="font-bold">{EMBAIXADOR}</p>

          </div>
        </div>
      </div>
    </div>
  );
};

export default BankStatement;